export enum LerePersonalisationCategory {
  AbandonedCart = 'abandoned_cart',
  HotLeads = 'hot_leads',
  // Sticky means the offers are from cache only
  StickyAbandonedCarts = 'sticky_abandoned_carts',
  StickyHotLeads = 'sticky_hot_leads',
  RecentlyViewed = 'recently_viewed',
  Alternatives = 'alternatives',
  PeopleLikeMe = 'people_like_me',
  UserPerference = 'preference'
}

export const VALID_TOUR_OFFER_TYPES = [
  'tour',
  'partner_tour',
  'direct_tour',
  'connection_tour',
]
export const ALTERNATIVES_RECENTLY_VIEWED_LIMIT = 7
export type Ratio = {
  antecedent: number
  consequent: number
}

export enum LereAggregationMode {
  Combine = 'combine',
  Select = 'select',
  Ensemble = 'ensemble'
}
